import { usePatientQuery } from "hooks/queries/usePatientQuery";
import { useConfig } from "render/context/ConfigContext";

const NekoLensSupportedPatientGroups: string[] = [
  "fcacd5b9-631e-47d4-9aa7-e953fbf9a0ba", // PatientGroup-ProdTesting-0
];

export function useShowNekoLens({ patientId }: { patientId: string }): boolean {
  const { stageType: environment } = useConfig();
  const { data: patientData } = usePatientQuery({ patientId });

  return (
    environment === "development" ||
    NekoLensSupportedPatientGroups.some(
      (value) => patientData?.groupIds.includes(value) ?? false
    )
  );
}
